<template>
	<az-container class="ma-0">
		<div class="arp-botoes-listagem-itens-ata mt-6 mb-3">
			<botao-primario
				v-az-auth="permissoes.ataOcorrenciaEditar"
				v-if="hasAuthority && totalItens > 0"
				nome-botao="ADICIONAR"
				icone="add_circle"
				class="botao-tamanho-arp mr-2"
				@click="abrirOuFecharModalInserirOcorrencia"
			></botao-primario>
		</div>
		<listar-ocorrencia
			:key="atualizaListagem"
			:has-authority="hasAuthority"
			v-az-auth="permissoes.ataOcorrenciaListar"
			:itens="itens"
			:total-paginas="totalPaginas"
			:paginacao="paginacao"
			:total-itens="totalItens"
			:id-entidade="idEntidade"
			:tipo-entidade="tipoEntidade"
			@resetar-page="resetarPaginaListagem"
			@paginar="setPaginacaoListagem"
			@carregar-listagem="buscarOcorrencias"
			@excluir="abrirOuFecharModalExcluirOcorrencia"
			@inserir="abrirOuFecharModalInserirOcorrencia"
		></listar-ocorrencia>
		<modal-inserir-ocorrencia
			v-if="exibirModalInserirOcorrencia"
			:exibir="exibirModalInserirOcorrencia"
			titulo-modal="Nova Ocorrência"
			@fechar-modal="abrirOuFecharModalInserirOcorrencia"
			@confirmar="salvarOcorrencia"
		></modal-inserir-ocorrencia>
		<modal-confirmacao
			:exibir="isExibirModalExcluirOcorrencia"
			titulo-modal="Atenção! Deseja excluir esta ocorrência?"
			mensagem="A ocorrência será removida definitivamente."
			@fechar-modal="abrirOuFecharModalExcluirOcorrencia"
			@confirmar="excluirOcorrencia"
		></modal-confirmacao>
	</az-container>
</template>
<script>
import { actionTypes, getterTypes, mutationTypes } from '@/core/constants'
import validacaoAta from '@/views/mixins/validacaoAta'
import ListarOcorrencia from '@/views/components/ocorrencia/listagem/listar/ListarOcorrencias.vue'
import BotaoPrimario from '@/views/components/BotaoPrimario.vue'
import ModalInserirOcorrencia from '@/views/components/ocorrencia/modal-inserir/ModalInserirOcorrencia.vue'
import ModalConfirmacao from '@/views/components/ModalConfirmacao.vue'
import { mapGetters, mapState } from 'vuex'

export default {
	name: 'listagem-ocorrencia',
	components: {
		ModalConfirmacao,
		ModalInserirOcorrencia,
		BotaoPrimario,
		ListarOcorrencia,
	},
	mixins: [validacaoAta],
	props: {
		idEntidade: {
			type: [String, Number],
			required: true,
		},
		tipoEntidade: {
			type: String,
			required: true,
		},
		hasAuthority: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			itens: [],
			paginacao: this.$store.state.ocorrencia.paginacao,
			totalItens: 0,
			totalPaginas: 0,
			exibirModalInserirOcorrencia: false,
			isExibirModalExcluirOcorrencia: false,
			idExcluirOcorrencia: null,
		}
	},
	computed: {
		...mapGetters({
			informacoesItens: getterTypes.OCORRENCIA.GET_INFORMACOES_ITENS_OCORRENCIA,
		}),
		...mapState({
			atualizaListagem: (state) => state.ocorrencia.atualizaListagem,
		}),
	},
	watch: {
		hasAuthority: {
			handler: 'buscarOcorrencias',
			immediate: true,
		},
		atualizaListagem: {
			async handler() {
				await this.buscarOcorrencias()
			},
		},
	},
	async created() {
		this.$store.commit(mutationTypes.OCORRENCIA.SET_INFORMACOES_OCORRENCIA, {
			idEntidade: this.idEntidade,
			tipoEntidade: this.tipoEntidade,
		})
		await this.buscarOcorrencias()
	},
	methods: {
		async buscarOcorrencias() {
			await this.$store.dispatch(actionTypes.OCORRENCIA.BUSCAR_OCORRENCIAS, {
				paginacao: this.paginacao,
				filtro: { idEntidade: this.idEntidade, tipoEntidade: this.tipoEntidade },
			})

			this.itens = this.informacoesItens.itens
			this.totalItens = this.informacoesItens.totalElements
			this.totalPaginas = this.informacoesItens.totalPages
		},
		abrirOuFecharModalInserirOcorrencia() {
			this.exibirModalInserirOcorrencia = !this.exibirModalInserirOcorrencia
		},
		async salvarOcorrencia(descricao) {
			await this.$store.dispatch(actionTypes.OCORRENCIA.INSERIR_OCORRENCIA, {
				descricao: descricao,
				idEntidade: this.idEntidade,
				entidadeTipo: this.tipoEntidade,
			})
			this.abrirOuFecharModalInserirOcorrencia()
			this.mostrarNotificacaoSucessoDefault()
			await this.buscarOcorrencias()
		},
		resetarPaginaListagem() {
			this.paginacao.page = 1
		},
		async excluirOcorrencia() {
			await this.$store.dispatch(actionTypes.OCORRENCIA.EXCLUIR_OCORRENCIA, {
				idOcorrencia: this.idExcluirOcorrencia,
				idEntidade: this.idEntidade,
				entidadeTipo: this.tipoEntidade,
			})
			this.abrirOuFecharModalExcluirOcorrencia()
			this.mostrarNotificacaoSucessoDefault()
			await this.buscarOcorrencias()
		},
		async setPaginacaoListagem(paginacao) {
			this.paginacao = paginacao
			await this.buscarOcorrencias()
		},
		abrirOuFecharModalExcluirOcorrencia(id) {
			this.idExcluirOcorrencia = id
			this.isExibirModalExcluirOcorrencia = !this.isExibirModalExcluirOcorrencia
		},
	},
}
</script>
<style lang="stylus" scoped></style>
